/**
 * TanStack Query hooks for `campaign-tz-scheduling`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	campaignTzSchedulingQueryKeys,
	type CreateCampaignTzSchedulingBody,
	type ListCampaignTzSchedulingResponse,
	type CampaignTzScheduleRow,
} from "./api";

export function useCampaignTzSchedulingList(): UseQueryResult<ListCampaignTzSchedulingResponse, Error> {
	return useQuery({
		queryKey: campaignTzSchedulingQueryKeys.list(),
		queryFn: list,
	});
}

export function useCampaignTzSchedulingCreate(): UseMutationResult<
	CampaignTzScheduleRow,
	Error,
	CreateCampaignTzSchedulingBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignTzSchedulingQueryKeys.all });
		},
	});
}

export function useCampaignTzSchedulingDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignTzSchedulingQueryKeys.all });
		},
	});
}
